<span multilang style="font-size: 0.75rem;color:var(--coralgrey)">
    {{zielText }}
</span>